import { PostOnboardingFormRequestBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const postOnboardingForm = async (
  payload: ApiRequest<PostOnboardingFormRequestBodyType>
) => {
  const resp = await api.post<ApiRequest<PostOnboardingFormRequestBodyType>>(
    "/v2/organizations/onboarding-form",
    payload
  );
  return resp.data;
};

export const usePostOnboardingForm = () => {
  return useMutation<
    ApiRequest<PostOnboardingFormRequestBodyType>,
    Error,
    any,
    any
  >({
    mutationFn: async (
      payload: ApiRequest<PostOnboardingFormRequestBodyType>
    ) => postOnboardingForm(payload),
  });
};
